<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Button, Container, Modal, Text } from '@Shelly/shelly-design-system';
	import { createEventDispatcher } from 'svelte';
	import { capFirstChar } from 'src/helpers/utilities';

	export let showModal: boolean = false;

	const dispatch = createEventDispatcher();

	const handleClose = () => {
		showModal = false;
		dispatch('close');
	};

	const handleConfirm = () => {
		dispatch('confirm');
	};
</script>

<Modal
	on:close={handleClose}
	{showModal}
	title={capFirstChar($format('alert_warning_device_sharing', { default: 'Device Sharing' }))}
	backdropClose={true}
	padding="0"
>
	<Container slot="content" class="p-s" padding="0">
		<Text>
			{$format('text_warning_if_change_profile_remove_shared_device', {
				default:
					'This device has been shared to other accounts. Switching its working profile will "unshare" it from those other accounts. Do you want to proceed?',
			})}
		</Text>
	</Container>
	<div slot="footer" class="d-flex justify-content-end">
		<Button
			variant="secondary"
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
			responsiveSize={{
				sm: 'm',
			}}
			on:click={handleClose}
		>
			{$format('button_cancel', { default: 'Cancel' })}
		</Button>
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
			responsiveSize={{
				sm: 'm',
			}}
			on:click={handleConfirm}
		>
			{$format('button_confirm', { default: 'Confirm' })}
		</Button>
	</div>
</Modal>
